import { render, staticRenderFns } from "./menuandvideo.vue?vue&type=template&id=50ff109c"
import script from "./menuandvideo.vue?vue&type=script&lang=js"
export * from "./menuandvideo.vue?vue&type=script&lang=js"
import style0 from "./menuandvideo.vue?vue&type=style&index=0&id=50ff109c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports